/**
 * Boot sequence, in the order it has to happen:
 *   1. runtime configuration (`/config.json`), because everything else reads it;
 *   2. in `npm run dev`, the fake API — before any store can issue a request;
 *   3. the session, so the router never renders against an unresolved identity;
 *   4. mount.
 */

import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router/index.js'
import { setRequestHandler } from './api/client.js'
import { loadConfig, usesFakeApi } from './config.js'
import { useTheme } from './composables/useTheme.js'
import { useAuthStore } from './stores/auth.js'

import './assets/styles/tokens.css'
import './assets/styles/base.css'

async function bootstrap() {
  await loadConfig()

  if (usesFakeApi) {
    const { handleFakeRequest } = await import('./dev/fakeApi.js')
    setRequestHandler(handleFakeRequest)
  }

  const app = createApp(App)
  app.use(createPinia())
  app.use(router)

  useTheme().initialize()
  await useAuthStore().initialize()

  await router.isReady()
  app.mount('#app')
}

bootstrap()
